
interface IProps{
    url: string;
    className: string;
}
export const ImgCrono = ({url,className}:IProps) => {
  return (
    <img
        src={url}
        alt="cronometro"
        className={className}
    />
  )
}
